import { SideAdvancedSearch } from "@/components/inputs/SideAdvancedSearch";
import SiteLayout from "@/components/layouts/SiteLayout";
import { PaginatedListingsList } from "@/components/lists/PaginatedList";
import ListingController from "@/server/controllers/ListingController";
import CommonUtils from "@/utils/CommonUtils";
import ListingsHelper from "@/utils/ListingsHelper";
import { useState } from "react";
import { LuSearch } from "react-icons/lu";
import { useEffect } from "react";

export async function getServerSideProps(context) {
  const queryParams = context.query;
  let page = queryParams.page ? parseInt(queryParams?.page) : 1;
  let pageSize = 20;
  let listingsData = await ListingController.getAllListings(
    page,
    pageSize,
    queryParams
  );
  listingsData = JSON.parse(JSON.stringify(listingsData));

  const locale = context.locale;
  let queryInfo = await ListingsHelper.getQueryPramsInfo(queryParams, locale);
  return { props: { listingsData, queryParams, queryInfo, page } };
}

const Listings = ({
  listingsData,
  queryParams,
  queryInfo,
  page: initialPage,
}) => {
  const [showFilter, setShowFilter] = useState(true);
  const [canLoadMore, setCanLoadMore] = useState(true);
  const [failedToLoadMore, setFailedToLoadMore] = useState(false);
  const [items, setItems] = useState(listingsData.data);
  const [page, setPage] = useState(initialPage);

  const toggleFilter = () => {
    setShowFilter(!showFilter);
    if (document.getElementById("navigation")) {
      var elements: any = document
        .getElementById("navigation")
        ?.getElementsByTagName("a");

      for (var i = 0, len = elements?.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if (elem.target.getAttribute("href") !== "") {
            if (elem.target.nextElementSibling) {
              var submenu = elem.target.nextElementSibling.nextElementSibling;
              submenu.classList.toggle("open");
            }
          }
        };
      }
    }
  };

  // useEffect(() => {
  //   console.log("Current page state: ", page);
  // }, [page]);

  // const onLoadMore = async () => {
  //   let queryParamsString = Object.keys(queryParams)
  //     .map((key) => key + "=" + queryParams[key])
  //     .join("&");

  //   const newPage = page + 1;
  //   setPage(newPage);

  //   console.log("onLoadMore", newPage, queryParams);

  //   setCanLoadMore(false);

  //   let results = await fetch(
  //     `/api/listings?page=${newPage}&${queryParamsString}`
  //   );

  //   let resultsJson = await results.json();

  //   //update items
  //   setItems([...items, ...resultsJson.data]);

  //   setCanLoadMore(resultsJson.hasNext);

  //   console.log("results", resultsJson.hasNext, resultsJson.data);
  // };

  return (
    <SiteLayout
      title={queryInfo.seoTitle + " | " + CommonUtils.appName}
      description={queryInfo.seoDescription}
    >
      <div className="container mx-auto sm:mt-auto -mt-[40px]">
        <div className="block md:flex md:space-x-4">
          <div className="sm:w-full md:w-[300px] ">
            <div className="flex justify-end">
              <button
                className="sm:flex md:hidden mb-4  text-right font-bold text-white bg-green-600 rounded p-2 items-center"
                onClick={toggleFilter}
              >
                <LuSearch className="inline-block mr-2" />
                <span>Tafuta </span>
              </button>
            </div>
            <div
              className={`${
                showFilter === true ? "hidden md:block " : "block mb-20 md:mb-0"
              }`}
            >
              <SideAdvancedSearch queryParams={queryParams} />
            </div>
          </div>
          <div className="flex-1">
            <PaginatedListingsList
              listings={items}
              gridClass={`gap-8 space-y-8 md:columns-3 columns-2`}
              currentPage={listingsData.page}
              queryParams={queryParams}
              queryInfo={queryInfo}
              hasNext={listingsData.hasNext}
              hasPrevious={listingsData.hasPrevious}
              totalPages={listingsData.totalPages}
              onLoadMore={() => {
                //onLoadMore();
              }}
              canLoadMore={canLoadMore}
            />
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};

export default Listings;
